import { Box, Button, Modal, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IDiagram } from 'store/ticket-service/types';

import { NamespacesList } from 'core/enums/common';

type FullViewDiagramModalProps = {
	handleCloseModal: () => void;
	diagram: IDiagram;
};

export const FullViewDiagramModal: FC<FullViewDiagramModalProps> = ({
	handleCloseModal,
	diagram,
}) => {
	const { t: useCasesTranslate } = useTranslation(NamespacesList['useCasesStep']);

	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	return (
		<>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: { xs: '95%', md: '85%' },
						maxWidth: 1200,
						bgcolor: 'background.paper',
						boxShadow: 24,
						outline: 'none',
						borderRadius: '8px',
						display: 'flex',
						justifyContent: 'center',
						maxHeight: '90%',
					}}
				>
					<Box
						sx={{
							width: '100%',
						}}
					>
						<Button
							type="button"
							sx={{
								position: 'absolute',
								top: '10px',
								right: '10px',
								minWidth: '24px',
								height: '24px',
								fontSize: '24px',
								color: '#9FA6B3',
							}}
							onClick={handleClose}
						>
							<span>&times;</span>
						</Button>

						<Box
							sx={{
								height: '100%',
								textAlign: 'center',
								display: 'flex',
								flexDirection: 'column',
								gap: '32px',
							}}
						>
							<Typography
								sx={{
									fontWeight: 700,
									marginTop: '16px',
								}}
							>
								{useCasesTranslate(`diagrams.${diagram.title}`)}
							</Typography>
							<Box
								sx={{
									display: 'flex',
									overflow: 'auto',
								}}
							>
								<img
									style={{ padding: '0 16px 16px', margin: 'auto' }}
									alt="test"
									src={diagram?.pictureLink}
								/>
							</Box>
						</Box>
					</Box>
				</Box>
			</Modal>
		</>
	);
};
